export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBqIR-2jNdoPNNog6JUrmyqJPPmOK-loz8',
    authDomain: 'eneza-dev.firebaseapp.com',
    databaseURL: 'https://eneza-dev.firebaseio.com',
    projectId: 'eneza-dev',
    storageBucket: 'eneza-dev.appspot.com',
    messagingSenderId: '278591921298',
    appId: '1:278591921298:web:24ca9c34d512e6cd8d5a4b',
    measurementId: 'G-1PV9CJ8PVH',
  },

  stripe: {
    key: 'pk_test_51LcoWVKQiEX6zGg8wNVMmaxBEzA2R2pqKlFfGnee7sM8kRKSAP4Hef2RTS8IRR9CynEPWVYyVIkoCJDZHHjms9x5008HuEeokF',
  },

  flutterWave: {
    key: 'FLWPUBK-92de9386e6ff4441c6957c43dd3c982b-X',
  },

  FUNCTIONS_URL: 'https://us-central1-eneza-dev.cloudfunctions.net',
};
